import { ReactNode } from 'react';

import { ActionBar } from '@dreryk/react-components';

type PatientPhoneNotificationActionBarProps = {
   readonly children: ReactNode;
};

export const PatientPhoneNotificationActionBar = (props: PatientPhoneNotificationActionBarProps): JSX.Element => {
   return (
      <ActionBar id='patient-phone-notification-action-bar' testId='patientPhoneNotification'>
         {props.children}
      </ActionBar>
   );
};
